import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { InvestigationPlan } from './types';

interface PriorityQuestionsPanelProps {
  plan: InvestigationPlan;
}

export const PriorityQuestionsPanel: React.FC<PriorityQuestionsPanelProps> = ({
  plan,
}) => {
  return (
    <Box sx={{ position: 'sticky', top: 16 }}>
      <Typography
        variant="overline"
        fontWeight={600}
        color="text.secondary"
        sx={{ display: 'block', mb: 2, letterSpacing: 0.5 }}
      >
        Priority Questions & Data
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {plan.targetedQuestions.map((group) => (
          <Paper
            key={group.id}
            elevation={0}
            sx={{
              p: 2.5,
              bgcolor: 'background.paper',
              border: 1,
              borderColor: 'divider',
              borderRadius: '8px',
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{ mb: 1.5, fontSize: '0.75rem', letterSpacing: 0.5 }}
            >
              <Box
                component="span"
                sx={{
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  color: 'primary.main',
                }}
              >
                {group.stakeholderType.replace(/_/g, ' ')}
              </Box>
              {group.stakeholderName && (
                <Box
                  component="span"
                  sx={{ fontWeight: 400, color: 'text.secondary' }}
                >
                  {` - ${group.stakeholderName}`}
                </Box>
              )}
            </Typography>
            {group.questions.map((question, idx) => (
              <Typography
                key={idx}
                variant="body2"
                sx={{
                  lineHeight: 1.5,
                  color: 'text.primary',
                  mb: idx === group.questions.length - 1 ? 0 : 1.5,
                }}
              >
                &ldquo;{question}&rdquo;
              </Typography>
            ))}
          </Paper>
        ))}
      </Box>
    </Box>
  );
};
